import React from 'react';
import {
  Modal,
  ModalBody,
  Spinner
} from "reactstrap";
import Select from "react-select";
import { useDispatch, useSelector } from 'react-redux';
import { updateDocumentJson } from '../../../slices/thunks';
import { useTranslation } from "react-i18next";

import { Formik, Form } from "formik";
import * as Yup from "yup";

const FileAssignModal = ({show, setShow, doc = {}, onReassignClickHandler}) => {
  // const dispatch = useDispatch();
  const { t } = useTranslation();
    
  const validationSchema = Yup.object().shape({
    ParaLegalIDs: Yup.array().of(Yup.string()).nullable(),
  });
    
  const { Users, Loading } = useSelector((state) => ({
    Users: state.Users.users,
    Loading: state.Users.loading
  }));

  return (
    <Modal isOpen={show} centered={true} size="md">
        <ModalBody className="py-3 px-5">
          <Formik
            enableReinitialize={true}
            initialValues={{
              ParaLegalIDs: doc.ParaLegalIDs || [], // store multiple IDs
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true);
              // const data = {
              //   DocID: doc.ID,
              //   JsonURL: doc.JsonURL,
              //   IsProcessed: true,
              //   IsSaved: true,
              //   Status: 3,
              //   DocumentTypeID: doc.DocumentTypeID,
              //   ParaLegalIDs: values.ParaLegalIDs,
              // }
              
              // dispatch(updateDocumentJson(data))
              // setShow(false);
              onReassignClickHandler(values.ParaLegalIDs);
              setSubmitting(false);
            }}
          >
            {({ isSubmitting, setFieldValue, values, touched, errors, isValid }) => (
              <Form>
                <div className="mt-2 text-center">
                  <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                    <h4 className="d-flex justify-content-start">
                      {t("Select paralegals")}
                    </h4>

                    {Loading ? (
                      <div className="d-flex justify-content-center align-items-center">
                        <Spinner style={{ height: "3rem", width: "3rem" }} className="me-2">
                          Loading...
                        </Spinner>
                      </div>
                    ) : (
                      <div className="text-start">
                        <Select
                          isMulti
                          name="ParaLegalIDs"
                          className={touched.ParaLegalIDs && errors.ParaLegalIDs ? 'is-invalid' : ''}
                          styles={{
                            multiValueLabel: (base) => ({
                              ...base,
                              color: "white", // text color of selected option
                            }),
                          }}
                          // menuPortalTarget={document.body}
                          menuPosition="fixed"
                          options={(Users || []).map((user) => ({
                            value: user?.ID,
                            label: user?.FullName,
                          }))}
                          value={values.ParaLegalIDs?.map((id) => {
                            const user = Users.find((u) => u.ID == id);
                            return user ? { value: user.ID, label: user.FullName } : null;
                          }).filter(Boolean)} // filter out nulls
                          onChange={(selectedOptions) => {
                            const values = selectedOptions.map((opt) => opt.value);
                            setFieldValue("ParaLegalIDs", values);
                          }}
                          noOptionsMessage={() => t("NoOptions")}
                        />

                        {touched.ParaLegalIDs && errors.ParaLegalIDs && (
                          <div className="invalid-feedback d-block">
                            {errors.ParaLegalIDs}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                  <button
                    type="button"
                    className="btn w-sm btn-light"
                    onClick={() => setShow(false)}
                  >
                    {t("Close")}
                  </button>
                  <button
                    type="submit"
                    className="btn w-sm btn-danger"
                    disabled={isSubmitting || Loading || !isValid}
                  >
                    {t("Save")}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
    </Modal>
  )
}

export default FileAssignModal
